import { createContext, useContext } from 'react';

import type { ServiceFetchCycler } from './use-service-fetch-cycler';

export interface AppContextType extends AppData {
  serviceCycler: ServiceFetchCycler;
}

export const AppContext = createContext<AppContextType | null>(null);

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('AppContext has not been initialized');
  }

  return context;
};
